export let CountryCode;

(function (CountryCode) {
  CountryCode["De"] = "de";
  CountryCode["Fr"] = "fr";
  CountryCode["Lt"] = "lt";
  CountryCode["Es"] = "es";
  CountryCode["Nl"] = "nl";
  CountryCode["Pl"] = "pl";
  CountryCode["Cz"] = "cz";
  CountryCode["Be"] = "be";
  CountryCode["Lu"] = "lu";
  CountryCode["Uk"] = "uk";
  CountryCode["Us"] = "us";
  CountryCode["At"] = "at";
  CountryCode["It"] = "it";
  CountryCode["Pt"] = "pt";
  CountryCode["Sk"] = "sk";
  CountryCode["Hu"] = "hu";
  CountryCode["Se"] = "se";
  CountryCode["Ro"] = "ro";
  CountryCode["Dk"] = "dk";
  CountryCode["Fi"] = "fi";
})(CountryCode || (CountryCode = {}));

export const UNKNOWN_COUNTRY_CODE = '--';